import { AdminDispatchTypes, ADMIN_FAIL, ADMIN_LOADING, ADMIN_SUCCESS } from '../actions/adminActionType';

// For now put adminInfo as any
// Later provide interface for adminInfo in types file
interface DefaultStateI {

    loading: boolean,
    isAuthenticated: boolean,
    adminInfo?: any,
    msg?: string

}

const defaultState: DefaultStateI = {

    loading: false,
    isAuthenticated: false,
    msg: ''

}

const adminReducer = ( state: DefaultStateI = defaultState, action: AdminDispatchTypes ): DefaultStateI => {

    switch( action.type ) {

        case ADMIN_FAIL:
            console.log("ADMIN FAIL",action.payload)
            return {
                loading: false,
                isAuthenticated: false,
                adminInfo: [ ],
                msg: action.payload
            }

        case ADMIN_LOADING:
            return {
                loading: true,
                isAuthenticated: false
            }

        case ADMIN_SUCCESS:
            return {
                loading: false,
                isAuthenticated: true,
                adminInfo: action.payload
            }

        default:
            console.log("This is default")
            return state
    
    };

};

export default adminReducer;